module.exports = __webpack_public_path__ + "img/ot-cdai_usdc.621f5aa2.png";